var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bag-price-container vertical center top" },
    [
      _c(
        "div",
        {
          staticClass: "horizontal top center",
          on: {
            change: function($event) {
              _vm.paramsChanged = true
            }
          }
        },
        [
          _c("bag-price-widget", {
            attrs: { searching: _vm.searching },
            on: { tabChanged: _vm.tabChanged, search: _vm.search }
          }),
          _vm._v(" "),
          _c("bag-price-info", { staticClass: "hide-md-lg hide-md hide-sm" })
        ],
        1
      ),
      _vm._v(" "),
      _c("bag-price-flight-select", {
        ref: "select",
        staticClass: "flight-select",
        class: { noheight: _vm.hideFlightSelect },
        attrs: {
          origin: _vm.origin,
          destination: _vm.destination,
          "done-searching": !_vm.searching,
          "is-existing": _vm.isExisting,
          "flight-data": _vm.flightData,
          "price-data": _vm.priceData,
          roundTrip: _vm.roundTrip
        },
        on: { select: _vm.select }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25e7b958", { render: render, staticRenderFns: staticRenderFns })
  }
}